import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import {
    PhoneIcon,
    ChatBubbleLeftRightIcon,
    AcademicCapIcon,
    ArrowRightIcon
} from '@heroicons/react/24/outline'
import EnquiryModal from '../../../components/Enquiry/EnquiryModal'
import { useState } from 'react'

const CTASection = () => {
    const [isEnquiryOpen, setIsEnquiryOpen] = useState(false)

    return (
        <>
            <section className="py-16 lg:py-24 bg-gradient-to-br from-primary-600 via-secondary-600 to-primary-800 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-20"></div>

                <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full mb-8">
                                <AcademicCapIcon className="w-10 h-10 text-white" />
                            </div>

                            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
                                Ready to Transform Your Career?
                            </h2>

                            <p className="text-xl text-white mb-8 max-w-3xl mx-auto">
                                Join thousands of successful professionals who have advanced their careers through quality education.
                                Get personalized guidance from our expert counselors.
                            </p>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="flex flex-col sm:flex-row gap-4 justify-center mb-12"
                        >
                            <button
                                onClick={() => setIsEnquiryOpen(true)}
                                className="btn-lg bg-white text-primary-600 hover:bg-gray-50 hover-glow inline-flex items-center justify-center space-x-2"
                            >
                                <ChatBubbleLeftRightIcon className="w-5 h-5" />
                                <span>Get Free Consultation</span>
                            </button>

                            <Link
                                to="/courses"
                                className="btn-lg border-2 border-white text-white hover:bg-gray-50 hover:text-primary-600 inline-flex items-center justify-center space-x-2"
                            >
                                <span>Explore Courses</span>
                                <ArrowRightIcon className="w-5 h-5" />
                            </Link>
                        </motion.div>

                        {/* Contact Info */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                            className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-white/90"
                        >
                            <div className="flex items-center space-x-3">
                                <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                                    <PhoneIcon className="w-6 h-6" />
                                </div>
                                <div className="text-left">
                                    <div className="text-sm opacity-75">Call Us</div>
                                    <div className="font-semibold">+91-9810530354</div>
                                </div>
                            </div>

                            <div className="flex items-center space-x-3">
                                <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
                                    <ChatBubbleLeftRightIcon className="w-6 h-6" />
                                </div>
                                <div className="text-left">
                                    <div className="text-sm opacity-75">WhatsApp</div>
                                    <div className="font-semibold">+91-9810530354</div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute top-20 left-10 w-20 h-20 bg-white/5 rounded-full animate-float"></div>
                <div className="absolute bottom-20 right-10 w-16 h-16 bg-white/5 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
                <div className="absolute top-1/2 left-20 w-12 h-12 bg-white/5 rounded-full animate-float" style={{ animationDelay: '4s' }}></div>
            </section >

            {/* Enquiry Modal */}
            < EnquiryModal
                isOpen={isEnquiryOpen}
                onClose={() => setIsEnquiryOpen(false)}
            />
        </>
    )
}

export default CTASection
